import type { ComponentProps } from "react";
import { Button as ButtonPrimitive } from "@base-ui/react/button";
import * as stylex from "@stylexjs/stylex";
import { Button as ShadcnButton, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils/index";
type ButtonProps = ComponentProps<typeof ShadcnButton> & {
  unstyled?: boolean;
};
function Button({
  className,
  unstyled = false,
  stylexStyle,
  style,
  ...props
}: ButtonProps) {
  if (unstyled) {
    const stylexProps = stylex.props(stylexStyle);
    return <ButtonPrimitive data-slot="button" className={cn("cursor-pointer disabled:cursor-not-allowed disabled:pointer-events-none", className, stylexProps.className)} style={typeof style === "function" ? state => ({
      ...stylexProps.style,
      ...style(state)
    }) : {
      ...stylexProps.style,
      ...style
    }} {...props} />;
  }
  return <ShadcnButton className={cn("cursor-pointer", className)} stylexStyle={stylexStyle} style={style} {...props} />;
}
export { Button, buttonVariants };
export type { ButtonProps };